module.exports = {"create_annually_inform":"Crear Informe Anual","date_range":"Rang de dates","create":"Crear","annually_inform":"Informe Anual"}


//////////////////
// WEBPACK FOOTER
// ./src/translates/cat/AnuallSumary.json
// module id = 583
// module chunks = 1